'use client';
import styled from 'styled-components';

import { breakpoints } from '@styles/breakpoint';
import { GridLayout, GridTemplateAreas, GridVariables } from '@styles/GridVariables';
import { Spacers } from '@styles/theme';

export const MainLayoutWrapper = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  padding-top: ${(props) => props.theme.dimensions.headerHeight};
  padding-bottom: ${Spacers.LG}rem;
`;

export const HeaderWrapper = styled.div`
  ${GridVariables};
  background-color: ${({ theme }) => theme.colors.backgroundLight};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  display: grid;
  grid-template-areas: ${GridTemplateAreas.mobile};
  grid-template-columns: ${GridLayout.mobile.columns};
  gap: ${GridLayout.mobile.gap};
  padding-inline: var(--mobile-gutter);
  border-bottom: ${(props) => `1px solid ${props.theme.colors.backgroundAccent}`};

  ${breakpoints.desktopOrBigger} {
    grid-template-columns: ${GridLayout.desktop.columns};
    gap: ${GridLayout.desktop.gap};
    grid-template-areas: ${GridTemplateAreas.desktop};
    padding: 0;
    border-bottom: ${(props) => `1px solid ${props.theme.colors.backgroundAccent}`};
  }
`;

export const HeaderContent = styled.div<{ $isAdmin?: boolean }>`
  display: grid;
  grid-column: 1 / -1;

  ${breakpoints.desktopOrBigger} {
    grid-column: ${(props) => (props.$isAdmin ? '1 / -1' : '2 / -2')};
    ${(props) => props.$isAdmin && `padding-right: ${Spacers.XXL}rem;`}
  }
`;
